import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchHomeDisplayConfig } from '@/api/member';

const points = [
  { key: 'cinema_creatorPlatformPoint1', icon: 'ri-magic-line', tone: 'text-accent-400 bg-accent-500/15' },
  { key: 'cinema_creatorPlatformPoint2', icon: 'ri-video-upload-line', tone: 'text-amber-400 bg-amber-500/15' },
  { key: 'cinema_creatorPlatformPoint3', icon: 'ri-funds-line', tone: 'text-emerald-400 bg-emerald-500/15' },
];

export default function PlatformPanel() {
  const { t } = useTranslation('cinema');
  const [platformUrl, setPlatformUrl] = useState('');

  useEffect(() => {
    void fetchHomeDisplayConfig()
      .then((config) => setPlatformUrl((config.creatorPlatformUrl || '').trim()))
      .catch(() => setPlatformUrl(''));
  }, []);

  const openPlatform = () => {
    if (platformUrl) {
      window.open(platformUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="rounded-2xl overflow-hidden border border-background-800/40">
      <div className="relative">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20creative%20technology%20artwork%20with%20glowing%20warm%20orange%20and%20golden%20particles%20and%20film%20production%20icons%20floating%20over%20a%20deep%20dark%20elegant%20backdrop%2C%20artistic%20futuristic%20creator%20studio%20vibe%2C%20soft%20bokeh%20and%20premium%20gradient%2C%20cinematic%20color%20grading%2C%20motivational%20digital%20art%2C%20high%20detail%2C%20no%20text%2C%20no%20people&width=1200&height=500&seq=creator-platform-bg-1&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/95 via-background-950/70 to-background-950/40"></div>

        <div className="relative p-5 md:p-7">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 rounded-full text-[10px] font-bold text-background-950 bg-accent-400 whitespace-nowrap">
              {t('cinema_creatorPlatformTag')}
            </span>
          </div>
          <h4 className="text-lg md:text-xl font-bold text-foreground-50 font-heading mb-1.5 flex items-center gap-2">
            <i className="ri-rocket-2-line text-accent-400"></i>
            {t('cinema_creatorPlatformTitle')}
          </h4>
          <p className="text-xs md:text-sm text-foreground-400 max-w-xl leading-relaxed">
            {t('cinema_creatorPlatformDesc')}
          </p>

          <div className="flex flex-wrap gap-2 mt-4">
            {points.map((p) => (
              <div
                key={p.key}
                className="flex items-center gap-2 px-3 py-2 rounded-xl bg-black/40 border border-white/10 backdrop-blur-sm"
              >
                <span className={`w-7 h-7 flex items-center justify-center rounded-lg ${p.tone}`}>
                  <i className={`${p.icon} text-sm`}></i>
                </span>
                <span className="text-xs text-foreground-200">{t(p.key)}</span>
              </div>
            ))}
          </div>

          <button
            type="button"
            onClick={openPlatform}
            disabled={!platformUrl}
            className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-background-950 bg-accent-500 hover:bg-accent-400 disabled:cursor-not-allowed disabled:opacity-40 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('cinema_creatorPlatformOpen')}
            <i className="ri-external-link-line"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
